import { apiPost } from '../api'

export const add_user = data => {
  return apiPost({
    endpoint: 'user/add_user',
    data: data
  })
}
